<script setup lang="ts">
import { cn } from '@/utils';

interface UnitDisplayProps {
	affix: string;
	affixPosition?: 'left' | 'right';
	isShown?: boolean;
	class?: string;
}

const props = withDefaults(defineProps<UnitDisplayProps>(), {
	affixPosition: 'right',
	isShown: true
});
</script>

<template>
	<span
		:class="
			cn(
				'absolute top-[66%] -translate-y-1/2 p-0 text-sm text-gray-500',
				props.affixPosition === 'left' ? 'left-2' : 'right-3',
				{ hidden: !props.isShown },
				props.class
			)
		"
	>
		{{ affix }}
	</span>
</template>
